import { render, staticRenderFns } from "./BusinessOverview.vue?vue&type=template&id=33ff04c2&scoped=true&"
import script from "./BusinessOverview.vue?vue&type=script&lang=ts&"
export * from "./BusinessOverview.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessOverview.vue?vue&type=style&index=0&id=33ff04c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff04c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
